// src/components/Shared/QRCodeHelper.js

import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const QRCodeHelper = ({ value, label, size = 150 }) => {
    return (
        <Box sx={{ textAlign: 'center' }}>
            {label && (
                <Typography variant="body1" sx={{ mb: 2 }}>
                    {label}
                </Typography>
            )}
            <QRCodeSVG value={value} size={size} />
            <Typography variant="body2" sx={{ mt: 2 }}>
                {value}
            </Typography>
        </Box>
    );
};

QRCodeHelper.propTypes = {
    value: PropTypes.string.isRequired,
    label: PropTypes.string,
    size: PropTypes.number,
};

export default QRCodeHelper;